// extracted by mini-css-extract-plugin
export default {"navItem":"navItem__S5B3J","text":"text__e7DZb","num":"num__yH+8y"};